import * as commonFun from '@editor/src/page/index/components/canvas/common';

import { RenderPostionType } from '@src/js/constant';
import { checkIsSelectable, getElementRect } from './utils';

import AnimSvg from '@src/framework/editor/src/page/index/components/canvas/anim-svg';
import Cursor from '@src/css/ppt-editor-cursor-global.less';
import ElementOverlay from '../element-overlay';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ElementWrapperModel from './element-wrapper-model';
import ElementWrapperPresenter from './element-wrapper-presenter';
import { GraphType } from '../../../../../../../../slide/infrastructure/module/dependent/shape-info/constant';
import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import connect from '@src/js/separate-logic/connect';
import { elementFromType } from '../element-types';
import { getSize } from  '../element-types/shape-element/utils';
import { stackTrace } from '@src/slide/infrastructure/module/dependent/taskManager/taskMonitor/taskDecorator';
import { CommonContainer } from '@src/js/service/component-service/commonContainer';
import styles from '@editor/src/page/index/components/canvas/slide.css';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { isGroupHasDomCompatibleElement, isAttachmentImageElement, isAudioElement, isGroupModel, isIframeShapeModel, isIframeShapeModelInTextMode, isVideoElement, isDomCompatibleElement } from '@src/slide/domain/ui-model/elements/element-judge';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';

// 1.声明props类型
interface IElementWrapperProps{
    // presenter props
    checkIsCroping: () => boolean;
    checkIsPreview: () => boolean;
    checkIsResizing: () => boolean;
    setRef: (name: string, ref: any) => void;
    getWrapperMouseDown: () => (e) => void;
    getWrapperMouseUp: () => (e) => void;
    getWrapperTouchStart: () => (e) => void;
    getWrapperTouchEnd: () => (e) => void;
    getWrapperMouseMove: () => (e) => void;
    handleDragDrop: () => void;
    handleDoubleClick: () => void;
    handleClick: () => void;
    handleMouseDown: (e, element) => void;
    handleMouseUp: (e, element) => void;
    handleEditorMouseDown: () => void;
    handleElementUpdate: () => void;
    setPrevent: () => void;
    getPrevent: () => boolean;

    // 父组件props
    element: any;
    domRefCallback: (ref) => void;
    refCallback: (ref) => void;
    elementRootId: string;
    getPageScale: () => number;
    fromScale: number;
    relativeRotate: number;
    relativeFlipH: number;
    relativeFlipV: number;
    taskGroup: any;
    event: any;
    sync: any;
    mobileEditMode: any;
    toScaleView: boolean;
    setPathRef: (key, ref) => void;
    serverRender: boolean;
    getMediaManager(): IMediaManager | undefined;
    getHistoryManager(): IHistoryManager;
}

/**
 * Element容器
 */
@stackTrace
export class ElementWrapper extends React.Component<IElementWrapperProps> {
    public static displayName = 'ElementWrapper'; // 声明displayName，单元测试用于查找组件

    // 2.设定默认值，防止出错
    public static defaultProps = {
        setRef: () => {
            // 处理domRef，增加注释，以符合no-empty-function校验规则
        },
        checkIsCroping: () => false,
        checkIsPreview: () => false,
        checkIsResizing: () => false,
    };

    public shouldNotRender(elementComponent): boolean {
        return (!elementComponent || this.props.element.hidden) as boolean;
    }

    public shouldNotRenderIframeInCanvasMode(elementComponent): boolean {
        const { element } = this.props;

        return this.shouldNotRender(elementComponent)
            // iframe 切为文字态时不算做 iframe，不渲染
            || isIframeShapeModelInTextMode(element)
            || ((isIframeShapeModel(element)
            && !(this.props.getMediaManager()?.elementKey === element.key
            && this.props.getMediaManager()?.isShowIframe)) && !browser.isMobile);
    }

    /* eslint-disable complexity */
    public render() {
        const { element, checkIsCroping, checkIsPreview, checkIsResizing, setRef, getWrapperMouseDown,
            getWrapperMouseUp, getWrapperTouchStart, getWrapperTouchEnd, handleDragDrop,
            handleDoubleClick, handleClick, getWrapperMouseMove, handleMouseDown, handleMouseUp } = this.props;

        if (
            // 非 dom 兼容元素
            !isDomCompatibleElement(element)
            // 若是组合元素，查看里面是否有 dom 兼容元素
            && !(isGroupModel(element) && isGroupHasDomCompatibleElement(element))
        ) {
            return null;
        }


        const ElementComponent = elementFromType(element.type) as any;

        if (this.shouldNotRenderIframeInCanvasMode(ElementComponent)) {
            return null;
        }

        /* 编辑态初始化 begin */
        /* 特别注意，编辑状态值都在这里初始化，不要在初始化以外区域使用store.states访问 */
        const isSelected = element.selected;
        const isCroping = checkIsCroping();
        const isPreview = checkIsPreview();

        const selectable = checkIsSelectable(element);
        const editable = this.isEditable(element);
        /* 编辑态初始化 end */

        const cursorMove = this.isCursorMove();
        const classes = classNames({
            [styles.slideItem]: true,
            [Cursor.auto]: !cursorMove,
            [Cursor.move]: cursorMove,
            [element.id]: true,
        });

        const tableResizing = element.type === UIModelType.TABLE && checkIsResizing();
        const rect = getElementRect({ element, tableResizing, useAdvHas: false  });
        const pointerEvents = this.getPointEvent();

        return (
            <CommonContainer
                type={this.containerType()}
                ref={(el) => {
                    setRef('domRef', el);
                    this.props.domRefCallback?.(el);
                }}
                key={element.key}
                className={classes}
                id={`slide-element-${element.key}`}
                onMouseDown={getWrapperMouseDown?.()}
                onMouseUp={getWrapperMouseUp?.()}
                onTouchStart={this.getTouchStartHandler()}
                onTouchEnd={this.getTouchEndHandler()}
                onDrop={handleDragDrop}
                onDoubleClick={handleDoubleClick}
                onMouseMove={getWrapperMouseMove?.()}
                onClick={handleClick}
                style={{
                    ...rect,
                    transform: this.transformForDIV(rect),
                    pointerEvents,
                    position: 'absolute',
                }}
                transform={this.transformForSVG(rect)}
            >
                <ElementComponent
                    component={element}
                    ref={(el) => {
                        setRef('elementRef', el);
                        this.props.refCallback?.(el);
                    }}
                    elementRootId={this.getElementRootId()}// 组合内元素传入根结点id
                    getPageScale={this.props.getPageScale}
                    rect={rect}
                    fromScale={this.props.fromScale}
                    region={RenderPostionType.CANVAS}
                    rotate={element.props.style.rotate ? element.props.style.rotate : 0}
                    isCroping={isCroping && isSelected}
                    draggable={editable && !isCroping}
                    isPreview={isPreview}
                    editable={editable}
                    selectable={selectable}
                    editorMouseDown={this.props.handleEditorMouseDown}
                    handleMouseDown={element.type === UIModelType.GROUP ? handleMouseDown : null}
                    handleMouseUp={element.type === UIModelType.GROUP ? handleMouseUp : null}
                    showSelectBorder={element.type !== UIModelType.CONNECTOR && isSelected}
                    borderDraggable={selectable && !isCroping}
                    relativeRotate={this.props.relativeRotate}
                    relativeFlipH={this.props.relativeFlipH}
                    relativeFlipV={this.props.relativeFlipV}
                    onElementUpdate={this.props.handleElementUpdate}
                    taskGroup={this.props.taskGroup}
                    event={this.props.event}
                    sync={this.props.sync}
                    mobileEditMode={this.props.mobileEditMode}
                    toScaleView={this.props.toScaleView}
                    setPrevent={this.props.setPrevent}
                    getPrevent={this.props.getPrevent}
                    setPathRef={this.props.setPathRef}
                    serverRender={this.props.serverRender}
                />
                <ElementOverlay
                    element={element}
                    historyManager={this.props.getHistoryManager()}
                >
                </ElementOverlay>
                {this.getSvgJSX(rect)}
            </CommonContainer>
        );
    }

    /**
     * 默认的 touchstart 事件处理逻辑中会选中当前元素，选中之后图片附件就可以响应事件
     * dc 图片附件默认逻辑是在 touchend 事件中打开预览，这样就移动端点击必然就会打开预览，无法操作浮动工具栏
     * 要解决这个问题，有两个办法：
     * 1. 图片附件选中逻辑放在 touchend 中执行，这样只有在第二次触摸的时候才会打开预览，这样需要改造图片附件的
     *    touchstart 和 touchend 处理逻辑，也就是目前这个解决办法
     * 2. 图片附件响应事件的判断不使用 model.selected，因为这个值是 touchstart 选中之后立即变更的，所以可以立马响应 touchend 事件，
     *    改为自己记录 selected 状态，保证 selected 在第一次 touchend 的时候再变更即可。
     *    但是实际操作之后发现，只在 image-element-container 中实现的话相对麻烦一点，需要在当前元素外围添加一个元素用来响应 touchend 事件
     *    记录 selected 为 true，并且监听 model.selected 为 false 的时候修改 selected 为 false，逻辑改动比较大
     * 暂时没找到更好的解决办法，就用了改动相对较小的方法1
     */
    private getTouchStartHandler = () => {
        const { element, getWrapperTouchStart } = this.props;
        // 除了图片附件之外的元素走默认逻辑
        return isAttachmentImageElement(element) ? null : getWrapperTouchStart?.();
    };
    private getTouchEndHandler = () => {
        const { element, getWrapperTouchStart, getWrapperTouchEnd } = this.props;
        // 除了图片附件之外的元素走默认逻辑
        if (!isAttachmentImageElement(element)) {
            return getWrapperTouchEnd?.();
        }
        return (event) => {
            getWrapperTouchStart?.()?.(event);
            getWrapperTouchEnd?.()?.(event);
        };
    };

    private containerType = () => ('div');

    private isInMobileSlideList = () => browser.isMobile && !this.props.mobileEditMode?.();

    private transformForDIV(rect) {
        return commonFun.transformOfRotate(rect);
    }

    private transformForSVG(rect) {
        return null;
    }

    private isCursorMove = () => {
        const { element } = this.props;
        if (isVideoElement(element) || isAttachmentImageElement(element)) {
            return true;
        }
        let cursorMove = false;
        // http://tapd.tencent.com/10143861/bugtrace/bugs/view?bug_id=1010143861073035567
        if (element.type === UIModelType.SHAPE
            && element.isTextOrPlaceholder
            && element.props.style.bgShape === GraphType.RECT) {
            cursorMove = true;
        }
        return cursorMove;
    };

    /* eslint-disable complexity */
    private getPointEvent = () => {
        const { element } = this.props;

        // 这个函数的逻辑太多了，单独把 image 的拿出来做判断吧
        if (element.type === UIModelType.IMAGE) {
            return this.getImageModelPointEvent(element);
        }
        if (element.type === UIModelType.SHAPE) {
            return this.getShapeModelPointEvent(element);
        }
        return !element.selectable
        || element.type === UIModelType.GROUP
        || element.type === UIModelType.CONNECTOR
        || (isIframeShapeModel(element) && !this.props.getMediaManager()?.isShowIframe) ? 'none' : 'auto';
    };

    private getShapeModelPointEvent(shapeModel: IShapeModel) {
        const { attachment } = shapeModel.props;
        if (attachment) {
            const { objKey } = attachment;
            const attachmentManager = shapeModel.getAttachmentManager();
            if (!objKey && attachmentManager?.isGhostAttachment(shapeModel)) {
                // 没有 objKey 表示没上传成功
                // 没有上传成功并且是幽灵元素，则禁止事件
                return  'none';
            }
        }
        return 'auto';
    }

    private getImageModelPointEvent(element) {
        // 视频默认是在 canvas 绘制封面+播放按钮，所以要禁止事件，便于可以点击到 canvas 中画的播放按钮
        if (isVideoElement(element)) {
            return 'none';
        }
        if (isAudioElement(element)) {
            return 'none';
        }
        return 'auto';
    }

    private isEditable = element => element.selectable
        && element.currentEditState === PPTEditorStateType.EDITABLE && !element.isTextMath;

    private getElementRootId = () => this.props.elementRootId || this.props.element.key;

    private getShapePathMap = () => {
        const slide = this.props.element.parent;
        const map = new Map();
        if (!slide?.timing) return map;
        slide?.timing?.tmRoot?.childTnLst?.forEach((seq) => {
            seq?.cTn?.childTnLst?.forEach((clickGroup) => {
                clickGroup?.cTn?.childTnLst?.forEach((effect) => {
                    effect?.cTn?.childTnLst?.forEach((detail) => {
                        this.handleAnim(detail, map);
                    });
                });
            });
        });
        return map;
    };

    private handleAnim = (detail, map) => {
        const presetClass = detail?.cTn?.presetClass;
        if (presetClass !== 'path') return;
        const id = detail?.cTn?.id;
        detail?.cTn?.childTnLst?.forEach((anim) => {
            if (anim?.type === 'tn_animMotion') {
                const path = anim?.path;
                const spId = _get(anim, 'cBhvr.tgtEl.spTgt.spid');
                if (map.has(spId)) {
                    map.get(spId).push({ path, id });
                } else {
                    map.set(spId, [{ path, id }]);
                }
            }
        });
    };

    private getShapePathList = () => {
        const shapeId = this.props.element.id;
        const map = this.getShapePathMap();
        return map.get(shapeId) || [];
    };

    private getSvgPathStyle = (rect) => {
        if (!this.props.element?.parent?.parent?.props) return {};
        const { slideWidth, slideHeight } = this.props.element.parent.parent.props;
        const { element: { props, type } = {} } = this.props;
        const { width, height, left, top } = getSize(rect, props);
        const translateX = width / 2;
        const translateY = height / 2;
        const yNum = type === 'Table' ? top : top + height;
        return {
            wrapperStyle: {
                width: slideWidth,
                height: slideHeight,
                transform: `translate(${-left}px,${-yNum}px)`,
                position: 'absolute',
                zIndex: -99999,
            },
            pathStyle: {
                translateX: left + translateX,
                translateY: top + translateY,
            },
        };
    };
    private getSvgJSX = (rect) => {
        if (!this.props.element?.parent?.parent?.props) return null;
        const pathList = this.getShapePathList();
        const {
            wrapperStyle = {},
            pathStyle: { translateX, translateY } = {},
        } = this.getSvgPathStyle(rect);
        const { slideWidth, slideHeight } = this.props.element.parent.parent.props;

        const { setPathRef } = this.props;
        return pathList.length ? (
            <AnimSvg
                pathList={pathList}
                styleObj={wrapperStyle}
                scaleX={slideWidth}
                scaleY={slideHeight}
                translateX={translateX}
                translateY={translateY}
                componentKey={this.props.element.key}
                setPathRef={setPathRef}
            />
        ) : null;
    };
}

export default connect(
    ElementWrapperPresenter,
    ElementWrapperModel,
    ElementWrapper,
);
